<div class="dropdown {{showDdl ? 'open' : ''}}">
  <div>
    <!--<i class="glyphicon armx-search"></i>-->
    <input type="text" value="{{searchTerm}}" class="form-control" placeholder="{{placeHolder}}" (input)="search($event)" [disabled]="isDisabled" />

  </div>
  <ul class="dropdown-menu">
    <li *ngFor="let item of tempContent; index as i" class="{{i==arrowkeyLocation? 'active' :''}}" (click)="change(item)">
    <a>{{item[key]}}</a>
    </li>
    
  </ul>
</div>
